export var AiResultType;
(function (AiResultType) {
    AiResultType["TIME_SERIES_RESULT"] = "time_series_chart";
    AiResultType["VERTICAL_BAR_RESULT"] = "vertical_bar_chart";
    AiResultType["TABLE_RESULT"] = "table";
    AiResultType["QUERY_RESULT"] = "query_result";
    AiResultType["DASHBOARD_RESULT"] = "dashboard";
    AiResultType["DASHBOARD_V2_RESULT"] = "dashboard_v2";
    AiResultType["IMPROVE_CONTEXT"] = "improve_context";
    AiResultType["PROPOSE_CHANGE"] = "propose_change";
})(AiResultType || (AiResultType = {}));
export const AGENT_SUGGESTION_TOOLS = [
    'generateDashboard',
    'runQuery',
    'runSql',
    'proposeChange',
    'findContent',
];
//# sourceMappingURL=types.js.map